import { Adapter } from '@fmnts/core';
import { IApiNextFormModal } from '../api-model/api-model';
import { FormModal } from '../model/form-modal';
import { ApiModalButtonAdapter } from './modal-button.adapter';

export class ApiModalAdapter implements Adapter<FormModal> {
  constructor(private modalButtonAdapter = new ApiModalButtonAdapter()) {}

  adapt(item: IApiNextFormModal): FormModal {
    return {
      key: item.key,
      buttons: (item.buttons || []).map((b) =>
        this.modalButtonAdapter.adapt(b),
      ),
      title: item.title,
      text: item.text,
      image: item.image || null,
    };
  }
}
